import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import { jsonb, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { customers } from './customers';

export const whatsappConversationStateEnum = pgEnum('whatsapp_conversation_state', [
  'menu',
  'orcamento_collecting',
  'orders_menu',
  'order_action',
  'awaiting_human',
]);

export type WhatsappConversationContext = {
  step?: number;
  answers?: Record<string, { value: string; label: string }>;
  /** ids dos pedidos listados em `orders_menu` — mapeia a escolha numérica pro sale.id real. */
  orderIds?: string[];
  /** pedido escolhido em `orders_menu`, usado em `order_action`. */
  selectedOrderId?: string;
};

export const whatsappConversations = pgTable('whatsapp_conversations', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  phone: text('phone').notNull().unique(),
  profileName: text('profile_name'),
  state: whatsappConversationStateEnum('state').notNull().default('menu'),
  context: jsonb('context').$type<WhatsappConversationContext>().notNull().default({}),
  customerId: uuid('customer_id').references(() => customers.id, {
    onDelete: 'set null',
  }),
  lastMessageAt: timestamp('last_message_at')
    .notNull()
    .$defaultFn(() => new Date()),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const whatsappConversationsRelations = relations(
  whatsappConversations,
  ({ one }) => ({
    customer: one(customers, {
      fields: [whatsappConversations.customerId],
      references: [customers.id],
    }),
  }),
);

export type WhatsappConversation = InferSelectModel<typeof whatsappConversations>;
export type CreateWhatsappConversationInput = InferInsertModel<
  typeof whatsappConversations
>;
export type UpdateWhatsappConversationInput = Partial<CreateWhatsappConversationInput>;
